import styled from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    color: ${ThemeColors.getGrayColor()};
    box-sizing: border-box;
`
export const Body = styled.div`
    padding: 1rem 0.5rem;

    & table {
        width: auto;
    }
`
